import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';

class CSSForm extends React.Component {

  renderTextArea = ({ input, label, meta: { touched, error, warning } }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <textarea
          {...input}
          className="form-control"
          placeholder={label}
          rows="10"
          cols="30"
        />
        {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
    } = this.props;

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>CSS</legend>
          <Field
            className="form-control"
            name="asset"
            component={this.renderTextArea}
            type="text"
            placeholder="CSS"
            label="CSS"
          />
        </fieldset>

        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

CSSForm = connect(state => ({
  formValues: getFormValues('currentUser')(state),
  initialValues: state.currentUser.data.clientAsset,
  enableReinitialize: true,
}))(reduxForm({ form: 'currentUser' })(CSSForm));
export default CSSForm;



// WEBPACK FOOTER //
// ./src/routes/my/components/CSSForm.js